import React, { useState } from 'react'
import { Link } from "react-router-dom";


const Hadear = () => {
  const [toggle, setToggle] = useState(false);

  const CloseClick = () => {
    setToggle(false);

  };
  return (
    <>

      <header className="header">
        <div className="header-top">
          <div className="container">
            <div className="header-top-wrap">
              <div className="header-top">
                <div className="header-top-social">
                  <span>Follow Us: </span>
                  <Link to="https://www.facebook.com/Pchs.satna/" target="_blank"><i className="fab fa-facebook-f" /></Link>
                  <Link to="https://www.instagram.com/pchschool?igsh=MTVpdHltbDl3N2lxbw%3D%3D" target="_blank"><i className="fab fa-instagram" /></Link>
                  <Link to="https://www.youtube.com/@PCHSSATNA/videos" target="_blank"><i className="fab fa-youtube" /></Link>
                  <Link to="https://wa.me/917987105491" target="_blank"><i className="fab fa-whatsapp" /></Link>
                </div>
              </div>
              <div className="header-top-right">
                <div className="header-top-contact">
                  <ul>
                    <li>
                      <Link to="https://share.google/Fsl3aMdnrCaBHv8Ae" target="_blank"><i className="far fa-location-dot" /> Swami Chowk, Mukhtiyarganj Satna (M.P.)</Link>
                    </li>
                    <li>
                      <a href="mailto:pchs.satna@gmail.com"><i className="far fa-envelopes" /> pchs.satna@gmail.com</a>
                    </li>
                    <li>
                      <Link to="tel:7987105491"><i className="far fa-phone-volume" /> +91 7987105491</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="main-navigation">
          <nav className="navbar navbar-expand-lg">
            <div className="container position-relative">
              <Link className="navbar-brand" to="/">
                <img src="assets/school/priyadarshani.png" style={{ height: "95px", width: "95px" }} alt="logo" />
              </Link>
              <div className="mobile-menu-right">

                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#main_nav" aria-expanded="false" aria-label="Toggle navigation">
                  <span className="navbar-toggler-mobile-icon"><i className="far fa-bars" /></span>
                </button>
              </div>
              <div className="collapse navbar-collapse" id="main_nav">
                <ul className="navbar-nav">
                  <li className="nav-item dropdown">
                    <Link className="nav-link active" to="/" data-bs-toggle="dropdown">Home</Link>
                  </li>
                  <li className="nav-item dropdown">
                    <Link className="nav-link dropdown-toggle" to="#" data-bs-toggle="dropdown">About Us</Link>
                    <ul className="dropdown-menu fade-down">
                      <li><Link className="dropdown-item" to="/about-us">About Us</Link></li>
                      <li><Link className="dropdown-item" to="/director-message">Director Message</Link></li>
                      <li><Link className="dropdown-item" to="/principal-message">Principal Message</Link></li>
                    </ul>
                  </li>
                  <li className="nav-item"><Link className="nav-link" to="/facility">Facility</Link></li>
                  <li className="nav-item"><Link className="nav-link" to="/activities">Activities</Link></li>
                  <li className="nav-item"><Link className="nav-link" to="/faculty">Faculty</Link></li>
                  <li className="nav-item"><Link className="nav-link" to="/top-result">Top Result</Link></li>
                  {/* <li className="nav-item"><Link className="nav-link" to="/gallery">Gallery</Link></li> */}
                  <li className="nav-item dropdown">
                    <Link className="nav-link dropdown-toggle" to="#" data-bs-toggle="dropdown"> Gallery</Link>
                    <ul className="dropdown-menu fade-down">
                      <li><Link className="dropdown-item" to="/gallery">Photo Gallery</Link></li>
                      <li><Link className="dropdown-item" to="/our-video"> Video Gallery </Link></li>
                    </ul>
                  </li>
                  <li className="nav-item"><Link className="nav-link" to="/blog">Our Blog</Link></li>
                  <li className="nav-item"><Link className="nav-link" to="/contact-us">Contact Us</Link></li>
                </ul>
                <div className="nav-right">
                  <div className="search-btn">
                  </div>
                  <div className="nav-right-btn mt-2">
                    <Link to="/contact-us" className="theme-btn"><span className="fal fa-pencil" />Apply Now</Link>
                  </div>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </header>




    </>
  )
}

export default Hadear